export function formatListTitle(items: string[]): string {
    const arr = items.filter(Boolean)
    const n = arr.length
    if (n === 0) {
        return ''
    }
    if (n === 1) {
        return arr[0]
    }
    if (n === 2) {
        return `${arr[0]} e ${arr[1]}`
    }

    return `${arr.slice(0, -1).join(', ')} e ${arr[n - 1]}`
}
